export default "__VITE_ASSET__ba6f8401__"